"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var add_1 = __importDefault(require("../../data/add"));

var MyAdd = function MyAdd(props) {
  var _UI = props.UI,
      linkBack = props.linkBack,
      insertPromise = props.insertPromise,
      _props$initial = props.initial,
      initial = _props$initial === void 0 ? {} : _props$initial,
      onUpdate = props.onUpdate;
  return react_1.default.createElement(add_1.default, {
    link: onUpdate || linkBack,
    linkBack: linkBack,
    promise: insertPromise,
    UI: function UI(props) {
      return react_1.default.createElement(_UI, Object.assign({
        isAdd: true
      }, props));
    },
    data: Object.assign({}, initial)
  });
};

exports.default = MyAdd;